import React from 'react';
import { X, Check, ArrowRight } from 'lucide-react';
import Reveal from './Reveal';
import { COMPARISON } from '../mock';

export default function Comparison() {
  const { inhouse, onbrand } = COMPARISON;
  return (
    <section className="bg-[var(--ob-bg-alt)] py-24 md:py-32">
      <div className="mx-auto max-w-[1280px] px-5 md:px-8">
        <Reveal className="mb-16 max-w-2xl">
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--ob-accent-dark)]">
            Do The Math
          </p>
          <h2 className="font-display text-4xl font-extrabold tracking-tight text-[var(--ob-ink)] md:text-6xl">
            Building an in-house team is slow &amp; expensive.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          {/* In-house */}
          <Reveal>
            <div className="flex h-full flex-col rounded-3xl border border-[var(--ob-line)] bg-white p-8">
              <h3 className="font-display text-2xl font-extrabold text-[var(--ob-ink)]">{inhouse.title}</h3>
              <p className="mt-1 text-sm text-[var(--ob-ink-soft)]">{inhouse.subtitle}</p>
              <ul className="mt-7 flex-1 space-y-3">
                {inhouse.rows.map((r) => (
                  <li key={r.label} className="flex items-center justify-between gap-4 border-b border-[var(--ob-line)] pb-3">
                    <span className="flex items-center gap-3 text-[var(--ob-ink-soft)]">
                      <X size={16} className="text-red-400" /> {r.label}
                    </span>
                    <span className="font-display font-bold text-[var(--ob-ink)]">{r.value}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-6">
                <div className="text-xs font-semibold uppercase tracking-wide text-[var(--ob-ink-soft)]">Total Liability</div>
                <div className="font-display text-3xl font-extrabold text-[var(--ob-ink)] line-through decoration-red-400/70">
                  {inhouse.total}
                </div>
                <div className="mt-3 flex flex-wrap gap-2">
                  {inhouse.footnotes.map((f) => (
                    <span key={f} className="rounded-full bg-[var(--ob-bg-alt)] px-3 py-1 text-xs text-[var(--ob-ink-soft)]">{f}</span>
                  ))}
                </div>
              </div>
            </div>
          </Reveal>

          {/* OnBrand */}
          <Reveal delay={120}>
            <div className="relative flex h-full flex-col rounded-3xl border-2 border-[var(--ob-accent)] bg-[var(--ob-ink)] p-8 text-white">
              <span className="absolute right-6 top-6 rounded-full bg-[var(--ob-accent)] px-3 py-1 text-xs font-bold text-[var(--ob-dark)]">Best Value</span>
              <h3 className="font-display text-2xl font-extrabold text-white">{onbrand.title}</h3>
              <p className="mt-1 text-sm text-white/60">{onbrand.subtitle}</p>
              <ul className="mt-7 flex-1 space-y-3">
                {onbrand.rows.map((r) => (
                  <li key={r.label} className="flex items-center justify-between gap-4 border-b border-white/10 pb-3">
                    <span className="flex items-center gap-3 text-white/80">
                      <Check size={16} className="text-[var(--ob-accent)]" /> {r.label}
                    </span>
                    <span className="font-display font-bold text-[var(--ob-accent)]">{r.value}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-6">
                <div className="text-xs font-semibold uppercase tracking-wide text-white/60">Total Investment</div>
                <div className="font-display text-3xl font-extrabold text-[var(--ob-accent)]">{onbrand.total}</div>
                <div className="mt-3 flex flex-wrap gap-2">
                  {onbrand.footnotes.map((f) => (
                    <span key={f} className="rounded-full bg-white/10 px-3 py-1 text-xs text-white/80">{f}</span>
                  ))}
                </div>
                <a
                  href="https://calendly.com/hello-onbrandadmin/30min" target="_blank" rel="noopener noreferrer"
                  className="ob-btn group mt-7 inline-flex items-center gap-2 rounded-full bg-[var(--ob-accent)] px-9 py-[1.15rem] text-lg font-bold text-[var(--ob-dark)] hover:bg-white"
                >
                  Apply For A Partnership
                  <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
                </a>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
